import styled, { css } from 'styled-components';

export const Input = styled.input`
  top: 0px;
  left: 0px;
  opacity: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  position: absolute;
`;

export const Button = styled.div`
  padding: 10px;
  display: ${(props) => (props.inline ? 'inline-flex' : 'flex')};
  cursor: pointer;
  min-width: 120px;
  position: relative;
  align-items: center;
  border-radius: 2px;
  justify-content: center;
  transition: all 0.3s ease;

  min-height: 24px;

  &:active {
    opacity: 0.3 !important;
  }

  ${({ disabled, secondary, hoverColor }) =>
    !disabled &&
    css`
      &:hover {
        opacity: 0.5;
      }
    `};

  ${({ disabled }) =>
    disabled &&
    css`
      &:hover {
        cursor: not-allowed;
      }
    `};

  ${({ size }) =>
    size === 'small' &&
    css`
      padding: 4px;
    `};

  ${({ color }) =>
    color &&
    css`
      background-color: ${color};
    `};

  ${({ secondary, color }) =>
    secondary &&
    css`
      background-color: transparent;
      justify-content: center;
    `};

  ${({ secondary, color, border }) =>
    secondary &&
    border &&
    css`
      box-shadow: inset 0px 0px 0px 2px ${color};
    `};
`;

export const Label = styled.div`
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  padding-left: 4px;
  position: relative;
  font-family: roboto, sans-serif;

  ${({ color, secondary }) =>
    secondary &&
    css`
      color: ${color};
      font-weight: 400;
    `};
`;

export const MarginRight = styled.div`
  display: flex;
  margin-right: 4px;
`;
